import BreadCrumb from './BreadCrumb';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import when from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import sortBy from 'lodash/sortBy';
import { connect } from 'react-redux';
import { updateActiveCanvasDrawer } from '../CanvasDrawers/duck';
import withProductCustomisation from '../../hocs/withProductCustomisation';
import withGlobalContent from '../../hocs/withGlobalContent';
import { matchDefaultCustomisation } from '../../utils/match-customisation';
import { getPageNumber } from './helpers';

const enhance = compose(
  connect(null, dispatch => ({
    handleToggleDrawer: key => dispatch(updateActiveCanvasDrawer(key)),
  })),
  withProductCustomisation,
  withGlobalContent,
  withProps(props => {
    const firstDrawer = props.completedDrawersMap.required.find(d => d.match(/-0$/));
    const items = props.items.reduce((items, item) => {
      if (matchDefaultCustomisation(props.productCustomisation, item)) {
        const pageNumber = getPageNumber(props, item);
        return pageNumber ? items.concat({ ...item, pageNumber }) : items;
      }
      return items;
    }, []);
    return {
      items: props.sortByPageNumber ? sortBy(items, 'pageNumber') : items,
      firstDrawer,
      isCTAVisible: !!(props.breadcrumbCTA &&
        props.completedDrawersMap.incomplete.some(d => d === firstDrawer)),
    };
  }),
  withHandlers({
    onClickCTA: props => () => props.handleToggleDrawer(props.firstDrawer),
  }),
  when(props => props.items.length <= 0, renderNothing, c => c)
);

export default enhance(BreadCrumb);



// WEBPACK FOOTER //
// ./src/client/js/view/components/BreadCrumb/index.js